import { Box } from '@mui/material'
import { useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { match } from 'ts-pattern'
import UserIconConnected from 'assets/icons/nucleo/18px_user-cap.svg'
import UserIcon from 'assets/icons/nucleo/18px_user.svg'
import { AuthModalContext } from 'components/Auth/AuthModalContext'
import { minWidthIcon } from 'components/Layout/Header/Header.style'
import { LinkButton } from 'components/LinkButton'
import { Button } from 'components/common/Button'
import { Loader, LoaderVariant } from 'components/common/Loader'

export const UserButton = () => {
  const { t } = useTranslation('common')
  const session = useSession()
  const { setModalParams } = useContext(AuthModalContext)

  return (
    <Box width="100%">
      {match(session)
        .with({ status: 'loading' }, () => (
          <Button
            icon={<Loader variant={LoaderVariant.PRIMARY} />}
            fullWidthOnMobile
          />
        ))
        .with({ status: 'unauthenticated' }, () => (
          <Button
            leftIcon={<UserIcon css={minWidthIcon} />}
            label={t('menu.account.notAuthenticated')}
            fullWidthOnMobile
            onClick={() =>
              setModalParams({
                state: 'SIGNIN',
                redirectUrl: window.location.pathname
              })
            }
          />
        ))
        .with({ status: 'authenticated' }, () => (
          <LinkButton
            fullWidthOnMobile
            prefetch={false}
            href="/account"
            passHref
            leftIcon={<UserIconConnected css={minWidthIcon} />}
            label={t('menu.account.authenticated')}
          />
        ))
        .exhaustive()}
    </Box>
  )
}
